import { createFileRoute } from '@tanstack/react-router';
import { DisplayTv } from '~/components/dashboards/company/DisplayTv';

/**
 * Display TV lives under Settings, not as a Company sub-tab (owner's nav call).
 * The component is both the settings screen and the slideshow engine; add
 * `?tv=1` to boot a wallboard straight into the rotation, and `?tv-preset=` to
 * pick the layout target.
 */
export const Route = createFileRoute('/_app/admin/display-tv')({
  component: () => (
    <div className="mx-auto max-w-7xl px-6 py-6">
      <h1 className="font-display text-3xl font-bold text-[var(--color-navy)]">Display TV</h1>
      <p className="mb-6 mt-1 text-sm text-[var(--color-ink-soft)]">
        Configure the office wallboard — which slides appear, how fast they rotate, and the TV
        it is tuned for. Start it fullscreen here, or bookmark the <code>?tv=1</code> URL on the
        TV itself so it boots straight into the rotation.
      </p>
      <DisplayTv />
    </div>
  ),
});
